module.exports = __webpack_public_path__ + "img/map.48fa91cd.png";